import * as _ from 'lodash';

export function union<T>(array1: T[], array2?: T[]): T[] {
    return _.union(array1, array2);
}
